export default __webpack_public_path__ + "static/media/October2012.eb09e172.png";